/**
 * TrialsPanel — sub-tab container for the Trials admin area.
 *
 * Two sub-tabs:
 *   - "Review queue" → TrialsReviewPanel (existing)
 *   - "Countdown"    → TrialCountdownPanel (warm conversion candidates)
 *
 * State lives in the URL hash so a reload preserves the sub-tab.
 */
import React, { useEffect, useState } from "react";
import { Inbox, Hourglass } from "lucide-react";
import TrialsReviewPanel from "./TrialsReviewPanel";
import TrialCountdownPanel from "./TrialCountdownPanel";

const TABS = [
  { id: "review", label: "Review queue", Icon: Inbox },
  { id: "countdown", label: "Countdown", Icon: Hourglass },
];

const SubTabButton = ({ id, label, Icon, active, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className={`inline-flex items-center gap-2 px-4 py-2 text-[12px] tracking-[0.14em] uppercase border-b-2 transition-colors ${
      active
        ? "border-[#7737F6] text-black"
        : "border-transparent text-zinc-500 hover:text-black"
    }`}
    data-testid={`trials-subtab-${id}`}
  >
    <Icon size={13} /> {label}
  </button>
);

export default function TrialsPanel() {
  const initial = (typeof window !== "undefined" && window.location.hash.replace("#", "")) || "review";
  const [sub, setSub] = useState(TABS.find((t) => t.id === initial) ? initial : "review");

  useEffect(() => {
    if (typeof window !== "undefined" && sub) {
      window.history.replaceState(null, "", `#${sub}`);
    }
  }, [sub]);

  return (
    <div data-testid="trials-panel-shell">
      <div className="border-b border-zinc-200 mb-6">
        <div className="flex gap-2">
          {TABS.map((t) => (
            <SubTabButton
              key={t.id}
              {...t}
              active={sub === t.id}
              onClick={() => setSub(t.id)}
            />
          ))}
        </div>
      </div>
      {sub === "review" && <TrialsReviewPanel />}
      {sub === "countdown" && <TrialCountdownPanel />}
    </div>
  );
}
